import { createSelector } from 'reselect';
export const getPriceBreakdownState = (checkout) => checkout.priceBreakdown;
export const getTotalPrice = createSelector(getPriceBreakdownState, state => state.totalPrice);
